import React from 'react';
import {
  Button,
  Flex,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
} from '@chakra-ui/react';
import ErrorAlert from 'web-react-ui/src/chakra/ErrorAlert';
import SimpleSelectField from 'web-react-ui/src/reactFinalForm/fields/SimpleSelectField';
import SimpleForm2 from 'web-react-ui/src/reactFinalForm/SimpleForm2';
import { required } from 'web-react-ui/src/reactFinalForm/validators';
import useRequest from 'shared/src/hooks/useRequest';
import Post from 'shared/src/interfaces/Post.interface';
import TextAreaField from './TextAreaField';

const reasonOptions = [
  {
    text: 'Select an option… ',
    value: '',
  },
  {
    text: 'I don’t like the visual',
    value: 'I don’t like the visual',
  },
  {
    text: 'Error in content',
    value: 'Error in content',
  },
  {
    text: 'Scheduled date is incorrect',
    value: 'Scheduled date is incorrect',
  },
  {
    text: 'Duplication or Repetitive',
    value: 'Duplication or Repetitive',
  },
  {
    text: 'Other',
    value: 'Other',
  },
];

const DeleteModal = ({ post, isOpen, onClose, onDelete }: {
  post: Post,
  isOpen: boolean,
  onClose: (response?: any) => void,
  onDelete: (formValues: any) => {}
}) => {
  const deleteRequest = useRequest(
    async (formValues: { reason: string, details?: string }) => {
      await onDelete(formValues);
      onClose();
    },
  );

  return (
    <Modal isOpen={isOpen} onClose={onClose} closeOnOverlayClick={false} isCentered>
      <ModalOverlay />
      <SimpleForm2 onSubmit={deleteRequest.run} loading={deleteRequest.loading} initialValues={{}}>
        <ModalContent>
          <ModalHeader>
            Delete {post?.campaignName}?
            <ErrorAlert title="Error Deleting Post" error={deleteRequest.error} />
          </ModalHeader>
          <ModalBody>
            <Flex direction="column" gap="1em">
              <Text>
                Select a reason for deleting the post so we can continue to refine
                the content we create for you.
              </Text>
              <SimpleSelectField name="reason" options={reasonOptions} validate={required} chakra />
              <TextAreaField name="details" placeholder="Specify any additional details..." />
            </Flex>
          </ModalBody>
          <ModalFooter gap="1em">
            <Button onClick={onClose}>Cancel, Keep Post</Button>
            <Button colorScheme="red" mr={3} type="submit">Yes, Delete Post</Button>
          </ModalFooter>
        </ModalContent>
      </SimpleForm2>
    </Modal>
  );
};

export default DeleteModal;
